import React, { useState, useEffect } from "react";
import {
    Form,
    Button,
    Row,
    Col,
    Upload,Modal,
    notification, Radio, Tooltip, Tag, Input, Table, Dropdown, Menu, Select, Popconfirm, Space, Empty
} from "antd";
import { NavLink } from "react-router-dom"
import { InfoCircleOutlined, DownOutlined } from '@ant-design/icons';
import { UploadChangeParam } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";
import {
    deleteTemplateCertificate, deleteTemplateAllCertificate, addTemplateCertificate, 
    getTemplateCertificate, addTemplateCertificateWithCert
} from "../../../axios/api.device"

import {
    getAllCertificates
} from "../../../axios/api.certificate"

import { gaEvent } from "../../../withTracker"
import { UploadOutlined, PlusOutlined } from "@ant-design/icons";
//import Modal from "antd/lib/modal/Modal";

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";

const { Item } = Form;
const { Option } = Select
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentCertificate = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [tableList, setTableList] = useState<any[]>([]);
    const [dataForm] = Form.useForm();
    const [lockScreenUrl, setLockScreenUrl] = useState<any>();
    const [homeScreenUrl, setHomeScreenUrl] = useState<any>();
    const [isUpload, setIsUpload] = useState<boolean>(false);
    const [lockScreenChanged, setLockScreenChanged] = useState<boolean>(false);
    const [homeScreenChanged, setHomeScreenChanged] = useState<boolean>(false);

    const [loading, setLoading] = useState<boolean>(false);
    const [isShowAddForm, setIsShowAddForm] = useState<boolean>(false);
    const [isSelectNewCertificate, setIsSelectNewCertificate] = useState<boolean>(false);
    const [dataList, setDataList] = useState<any[]>([]);
    const [certId, setCertId] = useState<string>('');
    const [fileType, setFileType] = useState<string>('Upload');

    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo()
    }, [])
    const getDataInfo = () => {        
        if (platform == "IOS" || platform == "macOS") {
            getTemplateCertificate(templateId).then((res) => {
                if (res && res.length > 0) {
                    console.log(res)
                    setTableList(res)
                    setShowTable(2)

                } else {
                    setShowTable(1)
                    setTableList([])
                }
            })
        }
    }
    const normFile = (e: any) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                setLoading(true)
                if (platform === "IOS" || platform === "macOS") {
                    const { password, certificateFile,fileType,fileUrl } = res;
                    var arg = {
                        Password: password ? password : "",
                        certificate: certificateFile ? (certificateFile[0]?.originFileObj) : "",
                        fileType,
                        fileUrl
                    }
                    if(isSelectNewCertificate)
                    {
                        addTemplateCertificate(templateId, arg).then(() => {
                            updateTemplate();
                            notification.success({ message: t("添加成功") });
                            getDataInfo();
                            setIsShowAddForm(false);
                            setIsSelectNewCertificate(false)
                            setLoading(false)
                            dataForm?.resetFields();
                        }, () => {
                            setLoading(false)
                        })
                    }
                    else {
                        addTemplateCertificateWithCert(templateId, certId).then(() => {
                            updateTemplate();
                            notification.success({ message: t("添加成功") });
                            getDataInfo();
                            setIsShowAddForm(false);
                            setIsSelectNewCertificate(false)
                            setLoading(false)
                            dataForm?.resetFields();
                        }, () => {
                            setLoading(false)
                        })
                    }
                }
            })
    }
    const deleteTemplateClick = (id: string) => {        
        if (platform === "IOS" || platform === "macOS") {
            deleteTemplateCertificate(id).then(() => {
                updateTemplate();
                notification.success({ message: t("移除成功") });
                dataForm.resetFields();                
                getDataInfo();
            })
        }
    }
    const deleteAllTemplateClick = () => {        
        if (platform === "IOS" || platform === "macOS") {
            deleteTemplateAllCertificate(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("删除成功") });
                dataForm.resetFields();                
                getDataInfo();
            })
        }
    }
    const beforeUpload = (file: File) => {
        return false;
    };

    const getDataList = () => {
        if (platform === "IOS" || platform === "macOS") {
            getAllCertificates({search:""}).then(res=>{
                setDataList(res)
            });
        }
    }
    
    const onCertChange = (v:any) =>{
        setCertId(v);
    }

    const options = dataList.map(d => <Option key={d.id} value={d.id}>{d.name}</Option>);

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle"> {t("证书")}</Col>
                {platform != "Android" && (
                    <Col style={{ marginLeft: 36 }}>
                        {templateTab?.availabilities?.map((c: any) => (
                            <Tooltip title={
                                i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                            }>
                                <Tag color="cyan">{c}</Tag>
                            </Tooltip >
                        ))}
                        {templateTab?.supervisedRequired && (
                            <Tooltip title={t("只适用于受监督设备")}>
                                <Tag color="purple">S</Tag>
                            </Tooltip>
                        )}
                    </Col>
                )}
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("分发企业证书,以使用符合企业要求的应用,网络等资源")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); gaEvent("templateContentWallpaper", "onClick", "addClick") }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                    // <>
                    //     <Row style={{ margin: "8px 16px 16px 50px", fontSize: "14px" }}> 分发企业证书,以使用符合企业要求的应用,网络等资源</Row>
                    //     <Row style={{ margin: "100px 16px 16px 50px", fontSize: "16px" }}>
                    //         <Button onClick={() => { addClick(); gaEvent("templateContentWallpaper", "onClick", "addClick") }} type="primary">
                    //             添加规则
                    //         </Button>
                    //     </Row>
                    // </>
                )}
                {showTable == 2 && (
                    <>
                        <div className="tAr">
                            <Dropdown
                                dropdownRender={() => (
                                    <Menu onClick={(e) => {
                                        setIsShowAddForm(true);
                                        e.key === "1" ? setIsSelectNewCertificate(true) : getDataList()
                                        gaEvent("templateCertificate", "onClick", "setIsShowAddForm");
                                    }}>
                                        <Menu.Item key={1}>{t("添加新证书")}</Menu.Item>
                                        <Menu.Item key={2}>{t("选择已有证书")}</Menu.Item>
                                    </Menu>
                                )}>
                                <Button type="primary">{t("添加证书")} <DownOutlined /></Button>
                            </Dropdown>
                        </div>
                        <Table 
                            dataSource={tableList} 
                            style={{ width: "100%" ,marginLeft:8}}
                            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                        >
                            <Table.Column
                                title={t("证书名称")}
                                key="name"
                                dataIndex="name"
                            ></Table.Column>
                            <Table.Column title={t("密码")} key="password" dataIndex="password"
                                render={(v) => {
                                    return v ? t("已配置") : t("未配置")
                                }}
                            ></Table.Column>

                            <Table.Column
                                title={t("上传时间")}
                                key="uploadTime"
                                dataIndex="uploadTime"
                            ></Table.Column>

                            <Table.Column
                                title={t("操作")}
                                key="id"
                                dataIndex="id"
                                render={(v: string, d: any) => {
                                    return (
                                        <Space>
                                        <Popconfirm
                                            title={`${t("确认移除证书")} ${d.name}？`}
                                            onConfirm={() => deleteTemplateClick(v)}
                                            okText={t("确认")}
                                            cancelText={t("取消")}
                                        >
                                            <a style={{ color: "#007ACC" }}>{t("移除")}</a>
                                        </Popconfirm>
                                      </Space>
                                    )
                                }}
                            ></Table.Column>
                        </Table>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { console.log("click save!") }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteAllTemplateClick() }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
            <Modal
                confirmLoading={loading}
                maskClosable={false}
                visible={isShowAddForm}
                title={isSelectNewCertificate ? t("添加新证书") : t("选择已有证书")}
                width={"650px"}
                okText={t("确认")}
                cancelText={t("取消")}
                onOk={() => { addTemplateClick(); }}
                onCancel={() => {
                    setIsShowAddForm(false)
                    setIsSelectNewCertificate(false)
                }}>
                <Form
                    style={{ width: "90%", marginTop: 36 }}
                    layout="horizontal"
                    form={dataForm}
                    labelCol={{ span: 6 }}
                    initialValues={{ tags: [], fileType: 'Upload' }}
                >
                    {isSelectNewCertificate && (
                        <>
                            <Row>
                                <Col span={24}>
                                    <Item label={<span>&nbsp;</span>} name="fileType" colon={false}>
                                        <Radio.Group onChange={(e)=>{setFileType(e.target.value)}}>
                                            <Radio value="Upload">上传文件</Radio>
                                            <Radio value="Url">文件链接</Radio>
                                        </Radio.Group>
                                    </Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                { fileType == 'Upload' && 
                                    <Item
                                        label={t("证书文件")}
                                        name="certificateFile"
                                        rules={[{ required: !isUpload }]}
                                        valuePropName="fileList"
                                        getValueFromEvent={normFile}
                                        extra={`${t("支持后缀文件")} .cer/.crt/.der/.pfx/.p12/.pem`}
                                    >
                                        <Upload
                                            style={{ width: "100%" }}
                                            maxCount={1}
                                            showUploadList={true}
                                            listType="text"
                                            beforeUpload={(beforeUpload)}
                                            accept=".cer,.crt,.der,.pfx,.p12,.pem"
                                        >
                                            <Button style={{ width: "100%" }} icon={<UploadOutlined />}>{t("点击上传")} </Button>
                                        </Upload>
                                    </Item>
                                }
                                { fileType == 'Url' && 
                                <Item
                                    label={t("文件链接")}
                                    name="fileUrl"
                                    rules={[{ required: true }]}
                                >
                                    <Input></Input>
                                </Item>
                                }
                                {/* <Col span={24}>
                                    <Item
                                        label={t("证书文件")}
                                        name="certificateFile"
                                        rules={[{ required: !isUpload }]}
                                        valuePropName="fileList"
                                        getValueFromEvent={normFile}
                                        extra={`${t("支持后缀文件")} .cer/.crt/.der/.pfx/.p12/.pem`}
                                    >
                                        <Upload
                                            style={{ width: "100%" }}
                                            maxCount={1}
                                            showUploadList={true}
                                            listType="text"
                                            beforeUpload={(beforeUpload)}
                                            accept=".cer,.crt,.der,.pfx,.p12,.pem"
                                        >
                                            <Button style={{ width: "100%" }} icon={<UploadOutlined />}>{t("点击上传")} </Button>
                                        </Upload>
                                    </Item>
                                </Col> */}
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Item label={t("密码")} name="password" >
                                        <Input.Password />
                                    </Item>
                                </Col>
                            </Row>
                        </>
                    )}
                    {!isSelectNewCertificate && (
                        <Row>
                            <Col span={24}>
                                <Item 
                                    label={t("证书")}
                                    name="selectCertificate"
                                    rules={[{ required: true, message: t('请选择证书') }]}
                                >
                                    <Select
                                        showSearch
                                        placeholder={t("请选择证书")}
                                        optionFilterProp="children"
                                        onChange={(v) => onCertChange(v)}
                                        // onSearch={(e) => {console.log("eeeee",e)}}
                                        filterOption={
                                            (input, option: any) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        { options }
                                    </Select>
                                </Item>
                            </Col>
                        </Row>
                    )}
                    
                </Form>

            </Modal>
        </div>

    </>)
};